if (!customElements.get('lusso-hover-video')) {
  customElements.define(
    'lusso-hover-video',
    class LussoHoverVideo extends HTMLElement {
      connectedCallback() {
        this.desktopVideo = this.querySelector('.ls-latest-drop__video--desktop');
        this.mobileVideo = this.querySelector('.ls-latest-drop__video--mobile');
        this.touchLayout = window.matchMedia('(max-width: 989px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onEnter = () => this.playDesktop();
        this.onLeave = () => this.pauseDesktop();
        this.onLayoutChange = () => this.syncPlayback();

        this.addEventListener('pointerenter', this.onEnter);
        this.addEventListener('pointerleave', this.onLeave);
        this.addEventListener('focusin', this.onEnter);
        this.addEventListener('focusout', this.onLeave);
        this.touchLayout.addEventListener?.('change', this.onLayoutChange);
        this.reducedMotion.addEventListener?.('change', this.onLayoutChange);
        this.syncPlayback();
      }

      disconnectedCallback() {
        this.removeEventListener('pointerenter', this.onEnter);
        this.removeEventListener('pointerleave', this.onLeave);
        this.removeEventListener('focusin', this.onEnter);
        this.removeEventListener('focusout', this.onLeave);
        this.touchLayout?.removeEventListener?.('change', this.onLayoutChange);
        this.reducedMotion?.removeEventListener?.('change', this.onLayoutChange);
      }

      play(video) {
        if (!video || this.reducedMotion.matches) return;
        const result = video.play();
        result?.then(() => video.classList.add('is-playing')).catch(() => video.classList.remove('is-playing'));
      }

      pause(video, reset = false) {
        if (!video) return;
        video.pause();
        video.classList.remove('is-playing');
        if (reset) video.currentTime = 0;
      }

      playDesktop() {
        if (!this.touchLayout.matches) this.play(this.desktopVideo);
      }

      pauseDesktop() {
        if (!this.touchLayout.matches) this.pause(this.desktopVideo);
      }

      syncPlayback() {
        if (this.reducedMotion.matches) {
          this.pause(this.desktopVideo, true);
          this.pause(this.mobileVideo, true);
        } else if (this.touchLayout.matches) {
          this.pause(this.desktopVideo, true);
          this.play(this.mobileVideo);
        } else {
          this.pause(this.mobileVideo, true);
          this.pause(this.desktopVideo, true);
        }
      }
    },
  );
}

(() => {
  const sections = document.querySelectorAll('[data-lusso-transition="horizon-ripple"]');
  if (!sections.length) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const update = () => {
    const viewport = window.innerHeight || document.documentElement.clientHeight;
    sections.forEach((section) => {
      if (reducedMotion.matches) {
        section.style.setProperty('--ls-horizon-progress', '1');
        return;
      }

      const rect = section.getBoundingClientRect();
      const progress = Math.min(1, Math.max(0, (viewport - rect.top) / (viewport * 0.82)));
      section.style.setProperty('--ls-horizon-progress', progress.toFixed(3));
    });
  };

  let ticking = false;
  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      update();
    });
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  reducedMotion.addEventListener?.('change', requestUpdate);
  update();
})();
